import React from 'react'
import BookmarksContainer from '../../../Components/Applications/Bookmarks'

export default function Bookmarks() {
  return (
    <div className='page-body'>
      <BookmarksContainer />
    </div>
  )
}